import React, { useState } from 'react';
import openEyeIcon from '../../assets/imgs/open-eye.svg';
import closeEyeIcon from '../../assets/imgs/close-eye.svg';

function PasswordField({ label, value, onChange, recoveryUrl, recoveryLabel }) {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ marginBottom: '15px', position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
        <label style={{ color: '#aaa', fontSize: '12px' }}>{label}</label>
        {recoveryUrl && recoveryLabel && (
          <label
            onClick={() => window.location.href = recoveryUrl}
            style={{ color: '#1c787e', fontWeight: 'bolder', cursor: 'pointer', fontSize: '12px' }}
          >
            {recoveryLabel}
          </label>
        )}
      </div>

      <img
        src={visible ? openEyeIcon : closeEyeIcon}
        alt="Toggle password visibility"
        onClick={() => setVisible(!visible)}
        style={{
          position: 'absolute',
          right: '12px',
          top: '35px',
          cursor: 'pointer'
        }}
      />

      <input
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          color: "#061B2B",
          fontWeight: "bold",
          fontSize: "14px",
          textAlign: "left",
          border: "1px solid #EBEBED",
          borderRadius: "4px",
          width: "100%",
          height: "35px",
          paddingLeft: "10px",
          backgroundColor: "#EBEBED"
        }}
      />
    </div>
  );
}

export default PasswordField;
